import { createActionGroup, props } from '@ngrx/store';
import { SrcNotificationSetting } from '../../../projects/client/apis/src-notification-settings/src-notification-settings.model';

export namespace SrcNotificationSettingsActions {
  export const getNotificationSettings = createActionGroup({
    source: 'SRC NOTIFICATION SETTINGS Get',
    events: {
      attempt: props<{ installationId: number }>(),
      success: props<{ data: SrcNotificationSetting }>(),
      error: props<{ error: string }>(),
    },
  });

  export const setNotificationSettings = createActionGroup({
    source: 'SRC NOTIFICATION SETTINGS Set',
    events: {
      attempt: props<{ installationId: number; isEnabled: boolean; threshold: string }>(),
      success: props<{ data: SrcNotificationSetting }>(),
      error: props<{ error: string }>(),
    },
  });
}
